export default __webpack_public_path__ + "static/Infrastructure-Optimization-f767adedafd83f61501d9ab8dddb0921.webp";